import React, { FC } from 'react';

import { Text } from '@moda/om';

export enum AccountTotalEntriesLabel {
  Designer = 'designer',
  Item = 'item',
  Order = 'order',
  Return = 'return',
  Shipment = 'shipment'
}

interface Props {
  label: AccountTotalEntriesLabel;
  totalEntries: number;
}

export const AccountTotalEntriesDescription: FC<Props> = ({ label, totalEntries }) => (
  <Text className="AccountTotalEntriesDescription" treatment="eyebrow">
    {`${totalEntries} ${label}${totalEntries === 1 ? '' : 's'}`}
  </Text>
);
